<template>
  <div class="hypervisor-migrate-results">
    <section v-for="group in groups" :key="`hv-group-${group.id}`" class="hypervisor-migrate-group">
      <table class="table table-striped table-bordered table-condensed">
        <thead>
          <tr>
            <th><div class="text-center">HyperVisor Name</div></th>
            <th><div class="text-center">Status</div></th>
            <th><div class="text-center">CPU</div></th>
            <th><div class="text-center">Type</div></th>
            <th class="hidden-tablet"><div class="text-center">IP address</div></th>
            <th><div class="text-center">Running VMs</div></th>
            <th class="hidden-tablet"><div class="text-center">Description</div></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><div class="text-center">{{ group.name }}</div></td>
            <td class="text-center"><span class="app-status-chip" :class="group.status_class">{{ group.status_label }}</span></td>
            <td><div class="text-center">{{ group.cpu_name }}</div></td>
            <td><div class="text-center">{{ group.hv_type_name }}</div></td>
            <td class="hidden-tablet"><div class="text-center">{{ group.ipaddress }}</div></td>
            <td>
              <div class="text-center">
                <span :id="`hypervisor-migrate-count-${group.id}`">{{ group.vm_count_value }}</span> (libvirt : {{ group.libvirt_vm_count }})
              </div>
            </td>
            <td class="hidden-tablet"><div class="text-center">{{ group.description }}</div></td>
          </tr>
        </tbody>
      </table>

      <table class="table table-striped table-bordered table-condensed">
        <thead>
          <tr>
            <th><div class="text-center">Name</div></th>
            <th><div class="text-center">Status</div></th>
            <th class="hidden-tablet"><div class="text-center">CPU</div></th>
            <th class="hidden-tablet"><div class="text-center">Memory</div></th>
            <th class="hidden-tablet"><div class="text-center">Boot</div></th>
            <th class="hidden-tablet"><div class="text-center">Network</div></th>
            <th><div class="text-center">Owner</div></th>
            <th style="width: 270px"><div class="text-center">Destination of Migration</div></th>
          </tr>
        </thead>
        <tbody :id="`hypervisor-migrate-body-${group.id}`" v-html="group.rows_html"></tbody>
      </table>
    </section>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'

const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({ groups: [] })
  }
})

const groups = ref(props.initialData?.groups || [])

function handleUpdate(event) {
  groups.value = event.detail?.groups || []
  window.setTimeout(() => {
    if (window.sccMountVueComponents) {
      window.sccMountVueComponents()
    }
  }, 0)
}

onMounted(() => {
  document.addEventListener('scc:hypervisor-migrate-results:update', handleUpdate)
  window.setTimeout(() => {
    if (window.sccMountVueComponents) {
      window.sccMountVueComponents()
    }
  }, 0)
})

onBeforeUnmount(() => {
  document.removeEventListener('scc:hypervisor-migrate-results:update', handleUpdate)
})
</script>

<style scoped>
.hypervisor-migrate-group + .hypervisor-migrate-group {
  margin-top: 24px;
}
</style>
